function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import styles from './notification.scss';
import template from './notification.html';

export var NotificationComponent = {
  template: template,
  styles: styles,
  bindings: {
    hmTitle: '@',
    hmDate: '@',
    hmShortText: '@',
    hmText: '@',
    hmLimit: '@',
    hmMoreText: '@',
    hmLessText: '@',
    hmDotsClass: '@',
    hmLinkClass: '@',
    hmDeliveryPlace: '@',
    markup: "@",
    thumbnail: "@",
    media: "<",
    hmIsRead: '<',
    hmIsOpen: '&',
    hmIsClose: '&',
    // onRemove: '&',
    hmGot: '&',
    learnMoreMp: '&',
    learnMoreProduct: '&',
    freeMode: '<' },

  controller: /*#__PURE__*/function () {NotificationComponentController.$inject = ["$scope", "$filter", "$sce"];
    function NotificationComponentController($scope, $filter, $sce) {
      "ngInject";_classCallCheck(this, NotificationComponentController);
      console.log(this);
      this.$scope = $scope;
      this.$filter = $filter;
      this.$sce = $sce;
      this.image = null;
      this.toggle = {
        dots: '...',
        dotsClass: this.hmDotsClass,
        linkClass: this.hmLinkClass };

    }_createClass(NotificationComponentController, [{ key: "$onInit", value: function $onInit()

      {
        //console.log('initialize');
        this.setToggleMoreText();
        this.setToggleLessText();
        this.validateLimit();
        this.setLessAndMoreText();
        this.setShowToggle();
        this.setCurrentToggleText();
        this.setLinkClass();
        this.setDotsClass();
        this.setImage();
      }

      // Toggle functions
    }, { key: "setToggleMoreText", value: function setToggleMoreText() {
        //console.log('setToggleMoreText');
        this.toggle.moreText = this.hmMoreText || 'Read more';
      } }, { key: "setToggleLessText", value: function setToggleLessText()

      {
        //console.log('setToggleLessText');
        this.toggle.lessText = this.hmLessText || 'Read less';
      } }, { key: "setCurrentToggleText", value: function setCurrentToggleText()

      {
        //console.log('setCurrentToggleText');
        this.toggle.text = this.toggle.state ? this.toggle.lessText : this.toggle.moreText;
      } }, { key: "setShowToggle", value: function setShowToggle()

      {
        //console.log('setShowToggle');
        this.toggle.show = this.moreText && this.moreText.length > 0;
      } }, { key: "setLinkClass", value: function setLinkClass()

      {
        //console.log('setLinkClass');
        this.toggle.linkClass = this.hmLinkClass;
      } }, { key: "setDotsClass", value: function setDotsClass()

      {
        //console.log('setDotsClass');
        this.toggle.dotsClass = this.hmDotsClass;
      } }, { key: "doToggle", value: function doToggle()

      {
        //console.log('doToggle');
        this.toggle.state = !this.toggle.state;
        this.showMoreText = !this.showMoreText;
        this.toggle.state ? this.hmIsOpen() : this.hmIsClose();
        this.setCurrentToggleText();
      }

      // If negative number, set to undefined
    }, { key: "validateLimit", value: function validateLimit() {
        //console.log('validateLimit');
        this.hmLimit = this.hmLimit && this.hmLimit <= 0 ? undefined : this.hmLimit;
      } }, { key: "getMoreTextLimit", value: function getMoreTextLimit()

      {
        //console.log('getMoreTextLimit');
        return this.hmLimit && this.hmLimit < this.hmText.length ? this.hmLimit - this.hmText.length : 0;
      } }, { key: "setLessAndMoreText", value: function setLessAndMoreText()

      {
        // console.log('setLessAndMoreText');
        if (this.markup === 'html') {
          this.lessText = this.hmShortText;
          this.moreText = this.$sce.trustAsHtml(this.hmText);
        } else {
          this.lessText = this.$filter('limitTo')(this.hmText, this.hmLimit);
          this.moreText = this.$filter('limitTo')(this.hmText, this.getMoreTextLimit());
        }
      } }, { key: "setImage", value: function setImage()

      {
        if (this.media && this.media.length && this.media[0].type === "image") {
          this.image = this.media[0].data.url;
        }
      } }]);return NotificationComponentController;}() };